var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F6277DEE-C1FE-4C38-BD65-3F804F1D39ED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-1291.000000, -119.000000)",
    fill: "#488FCB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown",
    transform: "translate(1274.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-(1)",
    transform: "translate(17.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,0 C3.36433412,0 0,3.36433412 0,7.5 C0,11.6356659 3.36433412,15 7.5,15 C11.6356659,15 15,11.6356659 15,7.5 C15,3.36433412 11.6356659,0 7.5,0 Z M7.5,11.8749618 C7.15496062,11.8749618 6.87503815,11.5950394 6.87503815,11.25 C6.87503815,10.9049606 7.15496062,10.6250382 7.5,10.6250382 C7.84503937,10.6250382 8.12496185,10.9049606 8.12496185,11.25 C8.12496185,11.5950394 7.84503938,11.8749618 7.5,11.8749618 L7.5,11.8749618 Z M8.48934173,7.90122984 C8.26812744,8.00308228 8.12496185,8.22624205 8.12496185,8.46942902 L8.12496185,8.75003815 C8.12496185,9.09496307 7.84561157,9.375 7.5,9.375 C7.15438843,9.375 6.87503815,9.09496307 6.87503815,8.75003815 L6.87503815,8.46942902 C6.87503815,7.7399826 7.30373382,7.07130434 7.96566009,6.76563264 C8.60252379,6.47254945 9.06246185,5.69435121 9.06246185,5.31246185 C9.06246185,4.45129395 8.36185456,3.75 7.5,3.75 C6.63814544,3.75 5.93753815,4.45129395 5.93753815,5.31246185 C5.93753815,5.65750122 5.65807342,5.93753815 5.31246185,5.93753815 C4.96685027,5.93753815 4.6875,5.65750122 4.6875,5.31246185 C4.6875,3.76190186 5.94932555,2.49996185 7.5,2.49996185 C9.05067445,2.49996185 10.3125,3.76190186 10.3125,5.31246185 C10.3125,6.15692139 9.57996369,7.3981476 8.48934173,7.90122984 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e6cf825216786b677350930ac56ce10b.svg";
export { ForwardRef as ReactComponent };